<template>
    <div>
      <!-- modal -->
      <b-modal
        id="nationalTrademarkOwnerFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="nationalTrademarkOwnerFormModal"
        :title=" $t('nationalTrademarkOwner.info')"
        :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')"
        cancel-variant="outline-secondary"
        @ok.prevent="addOrUpdate"
      >
      <validation-observer ref="infoRules" tag="form">
        <b-row>
          <b-col>
                  <b-form>
                    <validation-provider
                      :name=" $t('nationalTrademarkOwner.name')"
                      #default="{ errors }"
                      rules="required"
                    >
                    <b-form-group
                      :label=" $t('nationalTrademarkOwner.name')"
                      label-for="nationalTrademarkOwner"
                      :state="errors.length > 0 ? false:null"
                    >
                        <v-select 
                        id="nationalTrademarkOwner"
                        v-model="nationalTrademarkOwnerSelect"
                        :options="nationalTrademarkOwnerOption" 
                        label="name" 
                        @search="onSearch">
                        </v-select>
                          <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                            {{ errors[0] }}
                          </b-form-invalid-feedback> 
                    </b-form-group>
                    </validation-provider>
                  </b-form>
          </b-col>
        </b-row>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>

  export default {
    props: {
      nationalTrademarkId: Number, 
      getNationalTrademarkOwnerList: {type: Function},
      getNationalTrademarkList: {type: Function},
    },
    data() {
      return {
        id: 0,
        nationalTrademarkOwnerSelect: '',
        nationalTrademarkOwnerOption: [],
      }
    },
    methods: {
      showInfo() {
        this.$refs.nationalTrademarkOwnerFormModal.show()
      },
      onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search(loading, search, vm) {
      if(search.length > 2){
        const data = {name: search}
        const controller = { name: 'Client', actionName:'GetOwnerClientByName' }
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          this.nationalTrademarkOwnerOption = response.data.clientList
          loading(false)
        })
    }
    },
      addOrUpdate() {
        const data = {id: this.id, nationalTrademarkId: this.nationalTrademarkId, clientId: this.nationalTrademarkOwnerSelect.id}
        const controller = { name: 'NationalTrademarkOwner' }
        const payload = { data: data, controller: controller }
        this.$refs.infoRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('nationalTrademarkOwnerFormModal')
                    this.getNationalTrademarkOwnerList()
                    this.getNationalTrademarkList()
                    this.nationalTrademarkOwnerSelect = ''
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
              }
            })
          }
      },
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  [dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}
.agentInput {
  max-width: 87em !important;
  width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
  white-space: pre-wrap !important;
}
  </style>
  